import { connect } from 'react-redux'
import { state_update } from '../actions'
import AiOptionSet from './AiOptionSet'
import ReactGA from 'react-ga';
import {DEFAULT_STATE_VALUE, DEFAULT_ATTR_VALUE} from '../constants';

const mapStateToProps = (state, ownProps) => ({
  options: getOptions(state),
  cec:state.cec,
  cec2:state.cec2,
  headc:state.headc,
  rsetc:state.rsetc,
  ds:state.ds === DEFAULT_STATE_VALUE ?'HRD':state.ds,
  dict: DEFAULT_ATTR_VALUE[state.sh],
  dctw:state.dctw === DEFAULT_STATE_VALUE ?'1':state.dctw,
  head:state.head,
  hmet:state.hmet,
  rmet:state.rmet,
  rs:state.rs,
  esa:state['esa'],
  price1:state['price1'],
  esadetail:state['esadetail'],
  bl:state.bl,
  cross3:state.cross3,
  initial:state.initial,
  site:state.currentSite,
  sh:state.sh === DEFAULT_STATE_VALUE ?'R3':state.sh,
  inisku: state['initialSku'],
  sku: state['sku'],
  store:state.store,
  type: state['type'],
  optionSize: ownProps.optionSize === 'big' ? 120: 100,
  single_sc_option: (state['options_all'].indexOf('sc') !== -1 && state['sc'] === DEFAULT_STATE_VALUE) ? true : false,
  options_all: state['options_all'].join('-'),
  imageSize:ownProps.imageSize,
  orientation:ownProps.orientation,
  showReview: 'ai-show',
  title:state.title
})

function getOptions (state) 
{
  var res={};
  var all_options=state['options_all'];
  res['options_all'] = all_options;
  for (var i in all_options)
    {
      res['options_' + all_options[i]]= state['options_' + all_options[i]]
      res['value_' + all_options[i]]= state[all_options[i]]
/*      if (all_options[i] === 'sh')
      {
        console.log('shh',state)
      }*/

    }
  return res;  
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  onClick: ( () => dispatch(state_update({attr:ownProps.attr,value:ownProps.value}))),
  onESA: ( (val) => {
    //console.log('esaval',val)
    if (val===true)
    {
    dispatch(state_update({attr:'esaselected',value:true}))
    }
    else
    dispatch(state_update({attr:'esaselected',value:false}))
    
  }),
  onOpenReview: ( (e) => {
    console.log('review event')
    ReactGA.event({
    category: 'Review',
    action:'Review'})}
    )
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AiOptionSet)


// WEBPACK FOOTER //
// ./src/layout/AiOptionSetWrap.js